import React, { useEffect } from 'react';

import { useField } from 'formik';

import { IFile, useFiles } from '~/hooks/files';

import FileList from './FileList';
import FileUpload from './FileUpload';
import { CategorySubTitle, Container, Content, ErrorSpan } from './styles';

interface FileData {
  files: Array<IFile>;
  historyFiles: Array<IFile>;
}

interface FileProps {
  formFieldId?: string;
  label?: string;
  acceptedTypes?: string[];
  message?: string;
  multiple?: boolean;
  isRequired?: boolean;
}

const File: React.FC<FileProps> = ({
  formFieldId = 'fileInput',
  label = 'Arquivos',
  acceptedTypes,
  message,
  multiple = true,
  isRequired,
}) => {
  const { uploadedFiles, historyFiles, loadingHistoryFiles } = useFiles();

  const [field, meta, helpers] = useField<FileData | undefined>(formFieldId);
  const { value } = field;
  const { error } = meta;
  const { setValue } = helpers;

  useEffect(() => {
    const newHistoryFiles = historyFiles.filter(
      (historyFile) => historyFile.formFieldId === formFieldId,
    );
    const newUploadedFiles = uploadedFiles.filter(
      (uploadedFile) => uploadedFile.formFieldId === formFieldId,
    );

    setValue(
      newUploadedFiles?.length > 0 || newHistoryFiles?.length > 0
        ? {
            files: newUploadedFiles ?? [],
            historyFiles: newHistoryFiles ?? [],
          }
        : undefined,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadedFiles, historyFiles]);

  return (
    <Container>
      <Content isRequired={isRequired}>
        <span>{label}</span>
        {(multiple || (!multiple && (!value || value.files.length < 1))) && (
          <FileUpload
            customFileTypes={acceptedTypes}
            customMessage={message}
            formFieldId={formFieldId}
            multiple={multiple}
          />
        )}
        <FileList files={value?.files ?? []} />
        {!loadingHistoryFiles && value && value.historyFiles.length > 0 && (
          <>
            <CategorySubTitle>Histórico</CategorySubTitle>
            <FileList files={value?.historyFiles ?? []} canDelete={false} />
          </>
        )}
        {error && <ErrorSpan>{error}</ErrorSpan>}
      </Content>
    </Container>
  );
};

export default File;
